<template>
  <container id='pay' num='03' title='批发/团购'>
    <div :class='$style.container'>
      <div :class='$style.left'>{{groupBuy}}</div>
      <div :class='$style.right'>
        <div :class='$style.flexItem'>
          <lazy-image :class='$style.icon' :src='require("../assets/icon-phone.png")' />
          <div>
            <div>电话：</div>
            <a :href='`tel:${phone2}`'>{{phone2}}</a>
          </div>
        </div>
        <div :class='$style.flexItem'>
          <lazy-image :class='$style.icon' :src='require("../assets/icon-wechat.png")' />
          <div>
            <div>微信：</div>
            <div>微信扫描二维码或搜索 “{{phone2}}”</div>
            <lazy-image :class='$style.qrcode' :src='require("../assets/19821798128.jpg")' />
          </div>
        </div>
      </div>
    </div>
  </container>
</template>

<script>
import Container from "./Container";
export default {
  name: "GroupPay",
  components: { Container },
  data() {
    return {
      phone2: "",
      groupBuy: ""
    };
  },
  mounted() {
    this.phone2 = phones.phone2;
    this.groupBuy = window.company.groupBuy || "";
  }
};
</script>

<style lang='scss' module>
@import "../tool";
@media screen and (max-width: 750px) {
  .container {
    flex-direction: column;
  }
  .right {
    margin-top: rem(24);
  }
}
.container {
  display: flex;
}
.left {
  flex: 1;
  font-size: 16px;
  color: #000;
  text-align: left;
  text-align: justify;
  line-height: 1.5;
  letter-spacing: 2px;
}
.right {
  flex: 0.6;
  padding-left: 36px;
}
.flexItem {
  display: flex;
}
.flexItem ~ .flexItem {
  margin-top: 26px;
}
.icon {
  margin-right: 12px;
  width: 52px;
  height: 52px;
}
.qrcode {
  margin-top: 12px;
  width: 144px;
  height: 144px;
}
</style>